import { IEnumResponse } from '@/types'
import { autoCapitalize } from '@/utils/autoCapitalize'

class ProfessionalListMapper {
  toDomain(persistenceProfessionalData: IEnumResponse) {
    return {
      key: persistenceProfessionalData?.key,
      value: autoCapitalize(persistenceProfessionalData?.value),
    }
  }
}

export default new ProfessionalListMapper()
